function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", {
  id: "site_icon_svg__defs935"
}, React.createElement("style", {
  id: "style933"
}));

var SvgSiteIcon = function SvgSiteIcon(props) {
  return React.createElement("svg", _extends({
    width: 47.348,
    height: 38.742,
    id: "site_icon_svg__svg949"
  }, props), _ref, React.createElement("g", {
    transform: "scale(1.20227)",
    id: "site_icon_svg__g818"
  }, React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M19.691 0C12.938 0 7.162 4.252 4.834 10.238H1.716C.781 10.238 0 11.02 0 11.955v8.314c0 .935.781 1.716 1.716 1.716h3.118c2.328 5.987 8.104 10.239 14.857 10.239 6.754 0 12.53-4.252 14.858-10.239h3.117c.935 0 1.716-.78 1.716-1.716v-8.314c0-.935-.78-1.717-1.716-1.717h-3.117C32.22 4.252 26.445 0 19.69 0zm0 2.076c.599 0 1.208.271 1.859.91.65.638 1.298 1.636 1.848 2.91.526 1.223.963 2.697 1.277 4.342h-9.968c.314-1.645.75-3.119 1.278-4.341.55-1.275 1.197-2.273 1.848-2.911.65-.639 1.26-.91 1.858-.91zm-3.752.227c-.638.786-1.19 1.748-1.668 2.855-.631 1.464-1.128 3.184-1.465 5.08H6.769c1.716-3.857 5.07-6.802 9.17-7.935zm7.504 0c4.1 1.133 7.454 4.078 9.17 7.935h-6.036c-.338-1.896-.834-3.616-1.465-5.08-.478-1.107-1.03-2.07-1.669-2.855zM1.811 12.049h35.76v8.126H1.812zm4.318 1.318l1.446 5.49h1.917l.922-3.775.926 3.775h1.917l1.446-5.49h-1.706l-.927 3.745-.921-3.745H9.683l-.926 3.784-.922-3.784zm9.275 0l1.446 5.49h1.917l.922-3.775.926 3.775h1.917l1.446-5.49h-1.706l-.926 3.745-.922-3.745h-1.466l-.926 3.784-.922-3.784zm9.275 0l1.447 5.49h1.916l.922-3.775.926 3.775h1.917l1.446-5.49h-1.706l-.926 3.745-.922-3.745h-1.465l-.927 3.784-.922-3.784zM6.77 21.985h6.037c.337 1.897.834 3.617 1.465 5.08.477 1.108 1.03 2.07 1.668 2.856-4.1-1.133-7.454-4.078-9.17-7.936zm7.939 0h9.967c-.314 1.645-.75 3.12-1.277 4.342-.55 1.275-1.197 2.272-1.848 2.91-.651.64-1.26.91-1.859.91-.598 0-1.207-.27-1.858-.91-.65-.638-1.298-1.635-1.848-2.91-.527-1.222-.964-2.697-1.277-4.342zm11.869 0h6.036c-1.716 3.858-5.07 6.803-9.17 7.936.638-.786 1.191-1.748 1.669-2.855.63-1.464 1.127-3.184 1.465-5.08z",
    id: "site_icon_svg__path988",
    color: "#000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1.793,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "normal",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto"
  })));
};

export default __webpack_public_path__ + "c0db886e8463343585f7889ea1b23628.svg";
export { SvgSiteIcon as ReactComponent };